<button class="eid-current-user" (click)="openUserPanel()">
  <eid-avatar [first]="(currentUser$ | async)?.firstName" [second]="(currentUser$ | async)?.lastName"></eid-avatar>
  <mat-icon>arrow_drop_down</mat-icon>
</button>
